import { AxiosError } from 'axios';

// Response error keys vary across handlers: some return `{ error: ... }`,
// others `{ message: ... }`, and some include both (where `error` is a code
// like "voucher.expired" and `message` is human-readable). Prefer `message`
// when present, otherwise fall back to `error`. This avoids surfacing raw
// "Request failed with status code 409" strings to the user.
export function getErrorMessage(error: unknown, defaultMessage = 'An unexpected error occurred'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as { error?: string; message?: string } | undefined;
    if (data?.message && data.message.trim().length > 0) {
      return data.message;
    }
    if (data?.error && data.error.trim().length > 0) {
      return data.error;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return defaultMessage;
}
